export function buildAutomationSchedule(input) {
    const absoluteDays = input.scheduleMode === "custom"
        ? input.customSendDays
        : Array.from({ length: input.emailCount }, (_, index) => {
            if (input.scheduleMode === "fixed")
                return index * (input.intervalDays ?? 1);
            return input.emailCount === 1 ? 0 : Math.round(index * input.durationDays / (input.emailCount - 1));
        });
    if (absoluteDays.length !== input.emailCount || absoluteDays[0] !== 0 || absoluteDays.some((day, index) => !Number.isInteger(day) || day < 0 || (index > 0 && day <= absoluteDays[index - 1])))
        throw new Error("Invalid automation schedule");
    const absoluteSeconds = absoluteDays.map((day) => Math.round(day * 86_400));
    return absoluteSeconds.map((seconds, index) => ({
        position: index + 1,
        day: Number((seconds / 86_400).toFixed(4)),
        delaySeconds: index === 0 ? seconds : seconds - absoluteSeconds[index - 1]
    }));
}
